import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import api from '../../api/api'
// import buyBag from '../../assets/img/developing/bag.svg'
import CatalogMiniCard from '../../components/Catalog/CatalogMiniCard.jsx'
import Program from '../../components/Catalog/Program.jsx'
import Steps from '../../components/Catalog/Steps'
import Result from '../../components/Catalog/Result'
import Cookies from 'universal-cookie'
import { 
    // Button, 
    Row, 
    // Spinner 
} from 'reactstrap'
import { processError, isEmpty } from '../../lib/lib'
import Skeleton from '../../components/UI/Skeleton'
import CatalogCardPriceWrapper from '../../components/Catalog/CatalogCardPriceWrapper'
import BuyButton from '../../components/UI/BuyButton'
const cookies = new Cookies()

class ItemDesc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            itemInfo: {
                themes: [],
                teacherInfo: {},
                testAmount: 0,
                duration: 0,
                title: '',
                type: '',
                desc: '',
                newPrice: 0,
                oldPrice: 0,
                video: '',
                id: 0,
                process: [],
                result: [],
                alreadyHas: false,
                ableToSale: false,
                courses: [],
                buyUrl: '',
                currency: 'USD',
                teachersInfo: [],
            },
            addToCartAction: false,
            guidance: [],
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
            dataLoaded: false,
            guidanceLoaded: false,
            itemInfoLoaded: false,
        }
        // this.addToCart = this.addToCart.bind(this)
        this.routeToCatalog = this.routeToCatalog.bind(this)
    }

    routeToCatalog() {
        this.props.history.push('/catalog')
    }

    courseBuy(courseIds) {
        const token = cookies.get('accessToken')
        api.catalogBuy({ token, courseIds })
            .then(() => {
                this.props.history.push('/study')
                this.setState({ addToCartAction: false })
            })
            .catch((e) => {
                processError(e, this.props.history)
                this.setState({ addToCartAction: true })
            })
    }

    // addToCart(event) {
    //     event.preventDefault()
    //     this.setState({ addToCartAction: true })
    //     if (this.state.itemInfo.alreadyHas) {
    //         this.props.history.push(`/study`)
    //         return
    //     }
    //     if (this.state.itemInfo.buyUrl) {
    //         window.open(this.state.itemInfo.buyUrl, "_blank")
    //         this.setState({ addToCartAction: false })
    //         return
    //     }
    //     if (!this.state.itemInfo.newPrice) {
    //         this.courseBuy([this.state.itemInfo.id])
    //         return
    //     } else {
    //         const items = cookies.get('order') || []
    //         items.push({
    //             userId: cookies.get('userId'),
    //             itemId: this.state.itemInfo.id,
    //         })
    //         cookies.set('order', items, { path: '/' })
    //         this.props.history.push(`/cart`)
    //     }
    // }

    getThemes(id, token, lang) {
        return new Promise((resolve, reject) => {
            api.getCourseInfo(id, token, lang)
                .then((courseInfo) => resolve(courseInfo))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getItemInfo(data) {
        return new Promise((resolve, reject) => {
            api.getItemInfo(data)
                .then((itemInfo) => resolve(itemInfo))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getTestsAmount(themes) {
        return new Promise((resolve) => {
            try {
                const testAmount = ((themes.map((theme) => theme.modules.filter((mod) => mod.type === "test"))).map((arr) => arr.length)).reduce((a, b) => a + b)
                resolve(testAmount)
            } catch (e) {
                resolve(0)
            }
        })
    }

    getDuration(themes) {
        return new Promise((resolve) => {
            try {
                const duration = (themes.map((theme) => theme.duration)).reduce((a, b) => a + b)
                resolve(duration)
            } catch (e) {
                resolve(0)
            }
        })
    }

    getTeacherInfo(id, token, lang) {
        return new Promise((resolve, reject) => {
            api.getTeacherInfo(id, token, lang)
                .then((teacherInfo) => resolve(teacherInfo))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getGuidance(data) {
        return new Promise((resolve, reject) => {
            api.getGuidance(data)
                .then((guidance) => resolve(guidance))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const id = this.props.match.params.itemId
        const lang = this.props.i18n.language
        let arrPromise = [
            this.getGuidance({ id, token, lang }).then((guidance) => this.setState({ guidance, guidanceLoaded: true })),
            this.getItemInfo({ id, token, lang }).then(async (itemInfo) => {
                const { themes, teacherId, teacherIds, result, process } = itemInfo
                if (result && process) {
                    try {
                        itemInfo.result = JSON.parse(result)
                        itemInfo.process = JSON.parse(process)
                    } catch (e) {
                        itemInfo.result = []
                        itemInfo.process = []
                    }
                } else {
                    itemInfo.result = []
                    itemInfo.process = []
                }
                const testsAmount = await this.getTestsAmount(themes)
                const duration = await this.getDuration(themes)
                const teacherInfo = teacherId ? await this.getTeacherInfo(teacherId, token, lang) : null
                let teachersInfo = []
                if (!isEmpty(teacherIds)) teachersInfo = await Promise.all(teacherIds.map(async (teacherId) => await this.getTeacherInfo(teacherId, token, lang)))
                itemInfo.testAmount = testsAmount
                itemInfo.duration = duration
                itemInfo.teacherInfo = teacherInfo
                itemInfo.teachersInfo = teachersInfo
                this.setState({ itemInfo: {...itemInfo, ...itemInfo.catalog}, itemInfoLoaded: true })
            }),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <div className="content developing__content">
                    <div className="program">
                        {
                            this.state.itemInfoLoaded ?
                                <div className="program__offer">
                                    <div className="row">
                                        <div className="col-md-7 col-sm-12 program_left">
                                            <div className="program_left__content d-flex flex-column align-start justify-content-between page-title mt-0">
                                                <div className="breadcrumbs">
                                                    <span className="link md-font-size" onClick={() => this.props.history.push('/catalog')}>{t('catalog-catalog')}</span>
                                                    <span className="md-font-size"> / {this.state.itemInfo.title}</span>
                                                </div>
                                                <div>
                                                    <div className="program__subtitle md-font-size"><span>{t(`course-type-${this.state.itemInfo.type}`)}</span></div>
                                                    <h2 className="program__name xxl-font-size">{this.state.itemInfo.title}</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-5 col-sm-12 program__right d-flex align-items-end justify-content-end">
                                            {/* <img src={this.state.itemInfo.image} alt="man" /> */}
                                        </div>
                                    </div>
                                </div>
                                :
                                <Skeleton height={250} />
                        }
                        <div className="program__about program_margin">
                            <div className="row">
                                <div className="program__about_left col-xl-9 col-lg-12">
                                    {
                                        this.state.itemInfoLoaded && this.state.itemInfo.content && this.state.itemInfo.content.replace(/<\/?[^>]+(>|$)/g, "").replace('\n', '') ? 
                                            <h3 className="program__about_title section__title xl-font-size">{t('catalog-about')}</h3> : ''
                                    }
                                    {
                                        this.state.itemInfoLoaded ?
                                            <p className="program__about_text md-font-size" dangerouslySetInnerHTML={{ __html: this.state.itemInfo.content }}></p>
                                            :
                                            <Skeleton count={5} />
                                    }
                                    {
                                        this.state.itemInfoLoaded ?
                                            <React.Fragment>
                                                {
                                                    this.state.itemInfo.video ?
                                                        <iframe
                                                            width="100%"
                                                            height="400"
                                                            src={this.state.itemInfo.video}
                                                            frameBorder="0"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                            allowFullScreen
                                                            title={this.state.itemInfo.video}>
                                                        </iframe>
                                                        : ''
                                                }
                                            </React.Fragment>
                                            :
                                            <Skeleton height={400} />
                                    }
                                    <div className="program__include program_margin">
                                        <div className="row">
                                            <div className="col-12">
                                                {
                                                    this.state.dataLoaded && ((this.state.itemInfo.courses && this.state.itemInfo.courses.length) || (this.state.itemInfo.themes && this.state.itemInfo.themes.length)) ?
                                                        <h3 className="section__title xl-font-size">{t('catalog-includes')}</h3> : ''
                                                }
                                                {
                                                    this.state.dataLoaded ?
                                                        <React.Fragment>
                                                            {
                                                                this.state.itemInfo.type === 1 ?
                                                                    <Row>
                                                                        {
                                                                            this.state.itemInfo.courses.map((item) => (
                                                                                <CatalogMiniCard
                                                                                    key={item.id}
                                                                                    id={item.id}
                                                                                    image={item.image}
                                                                                    title={item.title}
                                                                                    desc={item.desc}
                                                                                    price={item.newPrice}
                                                                                    typeId={item.type}
                                                                                    courseType={'program'}
                                                                                    props={this.props}
                                                                                    cols={6}
                                                                                />
                                                                            ))
                                                                        }

                                                                    </Row>
                                                                    :
                                                                    this.state.itemInfo.themes.map((theme) => (
                                                                        <Program key={theme.id}
                                                                            id={theme.id}
                                                                            duration={theme.duration}
                                                                            title={theme.title}
                                                                            modules={theme.modules}
                                                                            props={this.props}
                                                                        />
                                                                    ))

                                                            }
                                                        </React.Fragment>
                                                        :
                                                        <React.Fragment>
                                                            <Program skeleton={true} />
                                                            <Program skeleton={true} />
                                                            <Program skeleton={true} />
                                                            <Program skeleton={true} />
                                                            <Row>
                                                                <CatalogMiniCard skeleton={true} cols={6} />
                                                                <CatalogMiniCard skeleton={true} cols={6} />
                                                            </Row>
                                                        </React.Fragment>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        this.state.itemInfoLoaded ?
                                            <React.Fragment>
                                                {
                                                    this.state.itemInfo.process.length ?
                                                        <div className="program__going program_margin">
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <h3 className="section__title xl-font-size">{t('catalog-about-study')}</h3>
                                                                    <Steps process={this.state.itemInfo.process} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''
                                                }
                                            </React.Fragment>
                                            :
                                            <div className="program__going program_margin">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <h3 className="section__title xl-font-size">{t('catalog-about-study')}</h3>
                                                        <Steps skeleton={true} />
                                                    </div>
                                                </div>
                                            </div>
                                    }

                                    {
                                        this.state.itemInfoLoaded ?
                                            <React.Fragment>
                                                {
                                                    this.state.itemInfo.result.length ?
                                                        <div className="program__result program_margin">
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <h4 className="section__title xl-font-size">{t('catalog-result')}</h4>
                                                                    <div className="result__cards-wrapper d-flex flex-wrap align-items-start justify-content-start">
                                                                        {
                                                                            this.state.itemInfo.result.map(({ title }, index) => (
                                                                                <Result
                                                                                    key={`result-desc-${index}`}
                                                                                    title={title}
                                                                                    index={index}
                                                                                />
                                                                            ))
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''
                                                }
                                            </React.Fragment>
                                            :
                                            <div className="program__result program_margin">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <h4 className="section__title xl-font-size">{t('catalog-result')}</h4>
                                                        <div className="result__cards-wrapper d-flex flex-wrap align-items-start justify-content-start">
                                                            <React.Fragment>
                                                                <Result skeleton={true} />
                                                                <Result skeleton={true} />
                                                                <Result skeleton={true} />
                                                            </React.Fragment>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                    }

                                    <div className="program__subscribe">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="program__subscribe_buy d-flex align-items-center justify-content-between flex-wrap">
                                                    {/* {console.log(this.state.itemInfo)} */}
                                                    <div className="program__subscribe_buy-cart">
                                                        {
                                                            this.state.itemInfoLoaded ?
                                                                <React.Fragment>
                                                                    {
                                                                        this.state.itemInfo.newPrice > 0 ?
                                                                            <div className='mx-auto mb-10px'>
                                                                                <CatalogCardPriceWrapper 
                                                                                    t={t}
                                                                                    oldPrice={this.state.itemInfo.oldPrice}
                                                                                    newPrice={this.state.itemInfo.newPrice}
                                                                                    currency={this.state.itemInfo.currency}
                                                                                    discount={this.state.itemInfo.discount}
                                                                                    size={'big'}
                                                                                    noSpace={true}
                                                                                />
                                                                            </div>
                                                                            : ''
                                                                    }
                                                                    <BuyButton className="program__subscribe_btn d-flex align-items-center justify-content-center" item={this.state.itemInfo.catalog} history={this.props.history} lang={this.props.i18n.language} />
                                                                    {/* <Button
                                                                        className="program__subscribe_btn d-flex align-items-center justify-content-center"
                                                                        onClick={this.addToCart}
                                                                        disabled={this.state.itemInfo.ableToSale || !this.state.addToCartAction ? false : true}
                                                                    >
                                                                        {
                                                                            this.state.addToCartAction ?
                                                                                <Spinner size="sm" />
                                                                                :
                                                                                <React.Fragment>
                                                                                    <img src={buyBag} alt="bag" />
                                                                                    <p className="sm-font-size">
                                                                                        {
                                                                                            this.state.itemInfo.alreadyHas === true ?
                                                                                                t('catalog-continue-study') :
                                                                                                this.state.itemInfo.ableToSale ?
                                                                                                    this.state.itemInfo.newPrice ?
                                                                                                        this.state.itemInfo.buyUrl ?
                                                                                                            t('catalog-buy') :
                                                                                                            t('catalog-purchase-program') :
                                                                                                        t('catalog-add-to-study') :
                                                                                                    t('catalog-on-sale-soon')
                                                                                        }
                                                                                    </p>
                                                                                </React.Fragment>
                                                                        }
                                                                    </Button> */}
                                                                </React.Fragment>
                                                                :
                                                                <React.Fragment>
                                                                    <Skeleton className="program__subscribe_oldprice lg-font-size d-block mx-auto mb-2" width={'20%'} />
                                                                    <Skeleton className="program__subscribe_price xl-font-size d-block mx-auto" width={'30%'} />
                                                                    <p className="program__subscribe_description md-font-size">{t('catalog-full-price')}</p>
                                                                    <Skeleton className="program__subscribe_btn d-flex align-items-center justify-content-center d-block mx-auto" width={'60%'} />
                                                                </React.Fragment>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="program__about_right col-xl-3 col-lg-12">
                                    {
                                        this.state.itemInfoLoaded ?
                                            <React.Fragment>
                                                {
                                                    this.state.itemInfo.type !== 1 &&
                                                    <div className="program__card">
                                                        <p className="program__card_title lg-font-size">{t('catalog-includes')}</p>
                                                        <div className="program__card_feature d-flex align-items-center justify-content-between">
                                                            <div className="feature__name md-font-size">{t('catalog-topics-number')}</div>
                                                            <div className="feature__value md-font-size">{this.state.itemInfo.themes.length}</div>
                                                        </div>
                                                        <div className="program__card_feature d-flex align-items-center justify-content-between">
                                                            <div className="feature__name md-font-size">{t('catalog-test-number')}</div>
                                                            <div className="feature__value md-font-size">{this.state.itemInfo.testAmount}</div>
                                                        </div>
                                                        <div className="program__card_feature d-flex align-items-center justify-content-between">
                                                            <div className="feature__name md-font-size text-capitalize">{t('catalog-minutes')}</div>
                                                            <div className="feature__value md-font-size">{this.state.itemInfo.duration}</div>
                                                        </div>
                                                        <div className="bottom__line"></div>
                                                        <div className="program__card_feature d-flex align-items-center justify-content-between">
                                                            <div className="feature__name md-font-size">{t('catalog-program-cost')}</div>
                                                            <div className="feature__value md-font-size">{this.state.itemInfo.newPrice || 0} {t('currency-' + this.state.itemInfo.currency)}</div>
                                                        </div>
                                                    </div>
                                                }
                                            </React.Fragment>
                                            :
                                            <div className="program__card">
                                                <p className="program__card_title lg-font-size">{t('catalog-includes')}</p>
                                                <div className="program__card_feature d-flex align-items-center justify-content-between">
                                                    <div className="feature__name md-font-size">{t('catalog-topics-number')}</div>
                                                    <Skeleton className="feature__value md-font-size" width={25} style={{ verticalAlign: 'middle' }} />
                                                </div>
                                                <div className="program__card_feature d-flex align-items-center justify-content-between">
                                                    <div className="feature__name md-font-size">{t('catalog-test-number')}</div>
                                                    <Skeleton className="feature__value md-font-size" width={25} style={{ verticalAlign: 'middle' }} />
                                                </div>
                                                <div className="program__card_feature d-flex align-items-center justify-content-between">
                                                    <div className="feature__name md-font-size text-capitalize">{t('catalog-minutes')}</div>
                                                    <Skeleton className="feature__value md-font-size" width={25} style={{ verticalAlign: 'middle' }} />
                                                </div>
                                                <div className="bottom__line"></div>
                                                <div className="program__card_feature d-flex align-items-center justify-content-between">
                                                    <div className="feature__name md-font-size">{t('catalog-program-cost')}</div>
                                                    <Skeleton className="feature__value md-font-size" width={25} style={{ verticalAlign: 'middle' }} />
                                                </div>
                                            </div>
                                    }

                                    <div className="program__card">
                                        {
                                            this.state.itemInfoLoaded && this.state.itemInfo.teachersInfo.length ?
                                                <p className="program__card_title lg-font-size">{t('catalog-program-curator')}</p> : ''
                                        }
                                        {
                                            this.state.itemInfoLoaded ?
                                                this.state.itemInfo.teachersInfo.length ?
                                                    this.state.itemInfo.teachersInfo.map((teacherInfo) => (
                                                        <React.Fragment key={teacherInfo.id}>
                                                            <div className="program__card_img-wrapper">
                                                                <img src={teacherInfo.image ? `${this.state.imageUrl}/${teacherInfo.image}` : "data:,"} alt="" className="program__card_img" onClick={() => this.props.history.push(`/author/${teacherInfo.id}`)} />
                                                            </div>
                                                            <p className="program__card_title lg-font-size">{teacherInfo.title}</p>
                                                            <div className="feature__name md-font-size" dangerouslySetInnerHTML={{ __html: teacherInfo.desc }}></div>
                                                        </React.Fragment>
                                                    ))
                                                    :
                                                    !isEmpty(this.state.itemInfo.teacherInfo) ?
                                                        <React.Fragment>
                                                            <div className="program__card_img-wrapper">
                                                                <img src={this.state.itemInfo.teacherInfo.image ? `${this.state.imageUrl}/${this.state.itemInfo.teacherInfo.image}` : "data:,"} alt="" className="program__card_img" onClick={() => this.props.history.push(`/author/${this.state.itemInfo.teacherInfo.id}`)} />
                                                            </div>
                                                            <p className="program__card_title lg-font-size">{this.state.itemInfo.teacherInfo.title}</p>
                                                            <div className="feature__name md-font-size" dangerouslySetInnerHTML={{ __html: this.state.itemInfo.teacherInfo.desc }}></div>
                                                        </React.Fragment>
                                                        : ''
                                                :
                                                <React.Fragment>
                                                    <div className="program__card_img-wrapper">
                                                        <Skeleton className="program__card_img" height={200} />
                                                    </div>
                                                    <Skeleton className="program__card_title lg-font-size p-0 mt-20px d-block mx-auto" width={'80%'} />
                                                    <Skeleton className="feature__name md-font-size d-block mx-auto p-0 mb-2" width={'80%'} />
                                                    <Skeleton className="md-font-size d-block mx-auto mb-20px" width={'80%'} />
                                                </React.Fragment>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        )
    }
}

ItemDesc.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    t: PropTypes.func,
    i18n: PropTypes.object,
}

export default withTranslation()(ItemDesc)



// WEBPACK FOOTER //
// ./src/views/Catalog/ItemDesc.jsx